import { NO_APLICA, NO_EVALUA } from "../../../../constants/structurals";
import { DerechoDto } from "../../../../interfaces/OpenData";
import Papa from "papaparse";
import { createExcel } from "../../../../utils/excel";

export type ColumnStructural = {
    derecho: string;
    dimension: string;
    subdimension: string;
    evaluacion: string;
};

export const buildStructuralColumns = (derechos: DerechoDto[]) => {
    const columnas: ColumnStructural[] = [];

    derechos.forEach((derecho) => {
        derecho.dimensiones.forEach((dimension) => {
            dimension.subdimensiones.forEach((sub) => {

                let valor = sub?.valoracion;

                if (valor === null) valor = NO_EVALUA;
                else if (valor?.toUpperCase?.() === NO_APLICA) valor = "";
                else valor = valor?.toUpperCase?.() ?? "";

                columnas.push({
                    derecho: derecho?.titulo ?? "",
                    dimension: dimension?.titulo ?? "",
                    subdimension: sub?.titulo ?? "",
                    evaluacion: valor
                });
            });
        });
    });

    return columnas
}

export const toUTF8CSV = (data: any) => {
    const csv = Papa.unparse(data, {
        quotes: true
    });
    const BOM = "\uFEFF";
    return BOM + csv;
};

export const escapeCSV = (value: string | number | null | undefined): string => {
    if (value === null || value === undefined) return "";
    const str = String(value);
    if (/[",\n]/.test(str)) {
        return `"${str.replace(/"/g, '""')}"`;
    }
    return str;
};

export const joinProperty = <T>(
    items: T[] | undefined,
    property: keyof T
): string => {
    return items
        ?.map(item => String(item[property]).replace(/\r?\n/g, ' '))
        .join(', ') || '';
};

export const toExcelBuffer = (rows: unknown[][]): Promise<Blob> =>
    createExcel(rows).toBlob();

export const saveAsExcel = (rows: unknown[][], fileName: string): Promise<void> =>
    createExcel(rows).toFile(`${fileName}.xlsx`);

export const buildPivotByAnioEncabezado = (
    dataset: { anio?: string | null; encabezado?: string; valor: string }[]
): unknown[][] => {
    const grouped = dataset.reduce((acc, curr) => {
        const { anio, encabezado, valor } = curr;
        if (!anio || !encabezado) return acc;
        if (!acc[anio]) acc[anio] = { Año: anio };
        acc[anio][encabezado] = valor;
        return acc;
    }, {} as Record<string, Record<string, string>>);

    const dataArray = Object.values(grouped).sort((a, b) => Number(a.Año) - Number(b.Año));
    const headers = Object.keys(dataArray[0] ?? {});
    return [headers, ...dataArray.map(r => headers.map(h => r[h] ?? ""))];
};